import IResult from 'src/dataModel/IResult';
import IReq from './IReq';
// import IResp from './IResp';
import Urls from 'src/config/Urls';
import http from 'src/utils/ajaxUtils';

/**
 * 接口描述
 * @param param 参数，IReq类型
 */
async function getNations(param: IReq): Promise<IResult<any>> {
  const resp = await http.get(Urls.getNationList, param);
  return resp;
}

export default getNations;


// WEBPACK FOOTER //
// ./src/api/IPManage/getNations/index.ts